import {AxiosInstance} from 'axios';
import {Test} from '../../models/test';
import {responseHandler} from './response';
import {Exam} from '../../models/exam';
import {Resource, ResourceType} from '../../models/resource';

export const getResources = async (client: AxiosInstance, params?: {
    [key in keyof Resource & {
        page: string
    }]: string
}) =>
    responseHandler<{
        resources: Resource[],
        recentResources: Partial<Resource & { date?: number }>[],
        resourceInfo:{ [key in ResourceType]?: number }
    }>(client.get(params ? `/resources?${Object.keys(params).map(value => `${value}=${params[value]}`).join('&')}` : "/resources"))

export const getResourceInfo = async (client: AxiosInstance) =>
    responseHandler<{ [key in ResourceType]?: number }>(client.get('/resources/info'))

export const getResource = async (client: AxiosInstance, resourceId: string) =>
    responseHandler<Resource>(client.get(`/resources/${resourceId}`))